import { render, staticRenderFns } from "./modal_new_related_institution.vue?vue&type=template&id=bd50b5dc&scoped=true"
import script from "./modal_new_related_institution.vue?vue&type=script&lang=js"
export * from "./modal_new_related_institution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd50b5dc",
  null
  
)

export default component.exports